import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/paper.png'


const _hoisted_1 = {
  class: "trezo-card p-[20px] md:p-[25px] rounded-md",
  style: {"background":"linear-gradient(164deg, #b95232 3.1%, #eb6d5c 99.22%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "trezo-card-content md:py-[30px] mx-auto md:max-w-[209px]" }, [
      _createElementVNode("h3", { class: "text-white text-lg md:text-xl leading-[1.3] mb-[16px]" }, " Have A Team More Than 10 Members? "),
      _createElementVNode("a", {
        href: "#",
        target: "_blank",
        class: "inline-block rounded-md bg-gray-900 text-white transition-all text-[15px] md:text-md font-medium py-[6px] px-[16.5px] hover:bg-gray-800 mb-[15px] md:mb-[30px]"
      }, " Upgrade Plans "),
      _createElementVNode("img", {
        src: _imports_0,
        class: "mx-auto",
        alt: "paper-image"
      })
    ], -1)
  ])))
}